import * as z from "zod"

export const signinSchema = z.object({
  userId: z.string(),
  rsaPublicKey: z.string(),
  protectedUserSymmetricKey: z.string(),
  protectedRsaPrivateKey: z.string(),
  protectedProfileSymmetricKey: z.string(),
})

export type SignInData = z.infer<typeof signinSchema>

export const EncryptedBlobBase64Schema = z.object({
  iv: z.string(),
  ciphertext: z.string(),
})

export type EncryptedBlobBase64 = z.infer<typeof EncryptedBlobBase64Schema>
